document.addEventListener('DOMContentLoaded', () => {
    function toggleSlickSlider() {
        const screenWidth = $(window).width();

        if (screenWidth <= 767) {
            if (!$(".enable-slider").hasClass("slick-initialized")) {
                $(".enable-slider").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 6000,
                    dots: true,
                    prevArrow: `<svg class="prev-arrow" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
<g filter="url(#filter0_d_10446_3576)">
<rect x="4" y="2.00012" width="25.4004" height="25.9998" rx="12.7002" fill="white" shape-rendering="crispEdges"/>
<path d="M18.3706 18.3403L15.0302 14.9999L18.3706 11.6596" stroke="#232323" stroke-width="0.686052" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_10446_3576" x="0" y="0.00012207" width="33.4004" height="33.9999" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10446_3576"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10446_3576" result="shape"/>
</filter>
</defs>
</svg>`,
                    nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none" class="next-arrow">
<g filter="url(#filter0_d_10446_3579)">
<rect x="30" y="27.9999" width="25.4004" height="25.9998" rx="12.7002" transform="rotate(-180 30 27.9999)" fill="white" shape-rendering="crispEdges"/>
<path d="M15.6296 11.6594L18.97 14.9998L15.6296 18.3402" stroke="#232323" stroke-width="0.686052" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_10446_3579" x="0.599609" y="0" width="33.4004" height="33.9999" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10446_3579"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10446_3579" result="shape"/>
</filter>
</defs>
</svg>`,
                    arrows: true,
                    infinite: true
                });
            }
        } else {
            if ($(".enable-slider").hasClass("slick-initialized")) {
                $(".enable-slider").slick("unslick");
            }
        }
    }

    // Run on load
    toggleSlickSlider();

    // Run on resize
    $(window).resize(function () {
        setTimeout(function () {
            toggleSlickSlider();
        }, 300);
    });
});